import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Gift } from "lucide-react";
import { STEPS } from "@/data/site";
import { SectionHead, FadeUp } from "@/components/site/Reveal";

export const Processus = () => (
  <section id="processus" className="relative py-24 md:py-36" data-testid="processus-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHead
        label="Comment ça marche"
        title={
          <>
            De l'idée à la mise en ligne, <span className="text-gradient">en 5 étapes.</span>
          </>
        }
        subtitle="Un parcours simple, transparent et sans surprise — avec un aperçu gratuit avant tout engagement."
      />

      <div className="relative">
        <div className="absolute left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-blue-500/40 via-violet-500/40 to-transparent hidden md:block" />
        <div className="flex flex-col gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, x: -32 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`relative md:pl-20 ${s.highlight ? "" : ""}`}
              data-testid={`step-${s.num}`}
            >
              <span
                className={`hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 w-[55px] h-[55px] rounded-full items-center justify-center font-display font-extrabold text-sm z-10 ${
                  s.highlight
                    ? "btn-gradient text-white shadow-[0_0_30px_rgba(124,58,237,0.5)]"
                    : "bg-[#101126] border border-white/[0.1] text-[var(--text-secondary)]"
                }`}
              >
                {s.num}
              </span>
              <div
                className={`rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 ${
                  s.highlight
                    ? "border border-violet-500/40 bg-gradient-to-r from-blue-600/[0.12] via-violet-600/[0.1] to-transparent shadow-[0_0_50px_-16px_rgba(124,58,237,0.4)]"
                    : "card-surface"
                }`}
              >
                <span className="md:hidden font-display font-extrabold text-2xl text-gradient">{s.num}</span>
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight">{s.title}</h3>
                    {s.highlight && (
                      <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-cyan-400/10 border border-cyan-400/30 px-3 py-1 font-mono-label text-[9px] tracking-[0.2em] uppercase text-[var(--accent-cyan)]">
                        <Gift size={11} /> Offert
                      </span>
                    )}
                  </div>
                  <p className="text-[var(--text-secondary)] text-sm md:text-base mt-2 leading-relaxed max-w-2xl">{s.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <FadeUp className="mt-12">
        <Link
          to="/demande"
          className="btn-gradient inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 font-semibold text-white"
          data-testid="processus-cta"
        >
          Lancer l'étape 1 — ma demande <ArrowRight size={17} />
        </Link>
      </FadeUp>
    </div>
  </section>
);

export default Processus;
